import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import theme from './theme';
import './index.css';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('NDA3Mjk2OUAzMzMwMmUzMDJlMzAzYjMzMzAzYkJsNDZiVCsyWlN3R1JCN1FvWUhaWEtxL2NFb0dRNkNpM1B0NE14MXVISk09;NDA3Mjk3MEAzMzMwMmUzMDJlMzAzYjMzMzAzYmRRT1h1d1hPSDFXOGJOWjFsZG4vbUtmeFRhQVNyYzFzc0xTZkZtemU2MlE9;Mgo+DSMBPh8sVXN0S0d+X1ZPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9mSH5Tf0RnWXxdcnNXQGlXUkQ=;ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH9TdkxiXX9dc3ZSQ2dZWkd2;NRAiBiAaIQQuGjN/VkZ+XU9HcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSdkVqWHtec3dXQWhUWE91Xw==;NDA3Mjk3NEAzMzMwMmUzMDJlMzAzYjMzMzAzYlVOMlFCUTM5RXJSVld6Lzl6aGhCTE41aTZMK0I4ejg0S3Jjd1AwY0RSaGM9;NDA3Mjk3NUAzMzMwMmUzMDJlMzAzYjMzMzAzYlE2QURmcjB0bFBVa1lXdHUvRklUdCthVkdDNFh6KzYrYUQrS0dJQzE2bDA9;Mgo+DSMBMAY9C3t3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH9TdkxiXX9dc3ZdT2hUWkd2;NDA3Mjk3N0AzMzMwMmUzMDJlMzAzYjMzMzAzYmFvd3FuSVYxY0l3aHFHa0d2TGNXUnlUSG5xR3JlMFk0Y0JHN2sxZ2ZyNzA9;NDA3Mjk3OEAzMzMwMmUzMDJlMzAzYjMzMzAzYldpL1FxSzVLbE0vOC9Db2hJSUY5Q3NvdTBYUkllZFdsNHU1VlVaWjVCTE09;NDA3Mjk3OUAzMzMwMmUzMDJlMzAzYjMzMzAzYlVOMlFCUTM5RXJSVld6Lzl6aGhCTE41aTZMK0I4ejg0S3Jjd1AwY0RSaGM9');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Router>
                <App />
            </Router>
        </ThemeProvider>
    </React.StrictMode>
);
